var centroids = {
    // AP: '非洲地区知识产权组织', // AP
    ARE: [53.847818, 23.424076],
    ARM: [45.038189, 40.069099],
    ARG: [-63.61667199999999, -38.416097],
    AUT: [14.550072, 47.516231],
    AUS: [133.775136, -25.274398],
    BIH: [17.679076, 43.915886],
    BGR: [25.48583, 42.733883],
    BRN: [114.727669, 4.535277],
    BHR: [50.3073846, 25.9406805],
    BOL: [-63.58865299999999, -16.290154],
    BEL: [4.469936, 50.503887],
    BRA: [-51.92528, -14.235004],
    BLR: [27.953389, 53.709807],
    CAN: [-106.346771, 56.130366],
    SUI: [8.227511999999999, 46.818188],
    CHI: [-71.542969, -35.675147],
    CHN: [104.195397, 35.86166],
    COL: [-74.297333, 4.570868],
    CRI: [-83.753428, 9.748916999999999],
    CUB: [-77.781167, 21.521757],
    CYP: [33.429859, 35.126413],
    CZE: [15.472962, 49.81749199999999],
    GER: [10.451526, 51.165691],
    DEU: [10.451526, 51.165691],
    DEN: [9.501785, 56.26392],
    DOM: [-71.2513808, 18.6665719],
    ALG: [1.659626, 28.033886],
    // EAP: '欧亚专利局', // EA
    ECU: [-78.18340599999999, -1.831239],
    EST: [25.013607, 58.595272],
    EGY: [30.802498, 26.820553],
    // EPO: '欧洲专利局', // EP
    ESP: [-3.74922, 40.46366700000001],
    FIN: [25.748151, 61.92410999999999],
    FRA: [2.213749, 46.227638],
    GBR: [-3.435973, 55.378051],
    // GCC: '海湾地区阿拉伯国家合作委员会专利局', // GC
    GEO: [-82.9000751, 32.1656221],
    GRE: [21.824312, 39.074208],
    GTM: [-90.23075899999999, 15.783471],
    HND: [-86.241905, 15.199999],
    CRO: [15.2, 45.1],
    HUN: [19.503304, 47.162494],
    IDN: [113.921327, -0.789275],
    IRL: [-8.24389, 53.41291],
    ISR: [34.851612, 31.046051],
    IND: [78.96288, 20.593684],
    ISL: [-19.020835, 64.963051],
    ITA: [12.56738, 41.87194],
    JPN: [138.252924, 36.204824],
    JOR: [36.238414, 30.585164],
    KEN: [37.906193, -0.023559],
    KOR: [127.766922, 35.907757],
    KAZ: [66.923684, 48.019573],
    LAO: [102.495496, 19.85627],
    LBN: [35.862285, 33.854721],
    LTU: [23.881275, 55.169438],
    LUX: [6.129582999999999, 49.815273],
    LAT: [24.603189, 56.879635],
    MAR: [-7.092619999999999, 31.791702],
    MNE: [19.37439, 42.708678],
    MKD: [21.745275, 41.608635],
    MOZ: [35.529562, -18.665695],
    MCO: [7.4083429, 43.7378501],
    MDA: [28.369885, 47.411631],
    MNG: [103.846656, 46.862496],
    MT: [14.2382654, 35.9423686],
    MWI: [34.301525, -13.254308],
    MEX: [-102.552784, 23.634501],
    MYS: [101.975766, 4.210484],
    NIC: [-85.207229, 12.865416],
    NLD: [5.291265999999999, 52.132633],
    NOR: [8.468945999999999, 60.47202399999999],
    NZL: [174.885971, -40.900557],
    // OAP: '非洲知识产权组织', // OA
    PAN: [-80.782127, 8.537981],
    PER: [-75.015152, -9.189967],
    PHL: [121.774017, 12.879721],
    POL: [19.145136, 51.919438],
    PRT: [-8.224454, 39.39987199999999],
    PRY: [-58.443832, -23.442503],
    ROU: [24.96676, 45.943161],
    SRB: [21.005859, 44.016521],
    RUS: [105.318756, 61.52401],
    SAU: [45.079162, 23.885942],
    SWE: [18.643501, 60.12816100000001],
    SGP: [103.7041632, 1.3139961],
    SVN: [14.995463, 46.151241],
    SVK: [19.699024, 48.669026],
    SM: [12.3900534, 43.9428566],
    SLV: [-88.89653, 13.794185],
    TUN: [9.537499, 33.886917],
    TTO: [-61.7721846, 10.6962001],
    THA: [100.992541, 15.870032],
    TJK: [71.276093, 38.861034],
    TUR: [35.243322, 38.963745],
    TWN: [121.5200760000, 25.0307240000],
    UKR: [31.16558, 48.379433],
    USA: [-95.712891, 37.09024],
    URY: [-55.765835, -32.522779],
    UZB: [64.585262, 41.377491],
    VNM: [108.277199, 14.058324],
    VEN: [-66.58973, 6.42375],
    // WIP: '世界知识产权组织', // WO
    ZAF: [22.937506, -30.559482],
    ZMB: [27.849332, -13.133897],
    ZWE: [29.154857, -19.015438],
};
/* 后续需要支持其他国家，从这里取 */
export var notSupportList = {
    // AD  "安道尔",
    AF: [67.709953, 33.93911],
    // AG  "安提瓜和巴布达",
    // AI  "安圭拉",
    AL: [20.168331, 41.153332],
    AO: [17.873887, -11.202692],
    AQ: [69.348557, -49.280366],
    // AS  "美属萨摩亚",
    // AW  "阿鲁巴",
    // AX  "奥兰",
    AZ: [47.576927, 40.143105],
    // BB  "巴巴多斯",
    BD: [90.356331, 23.684994],
    BF: [-1.561593, 12.238333],
    BI: [29.918886, -3.373056],
    BJ: [2.315834, 9.30769],
    // BL  "圣巴泰勒米",
    BM: [-64.7505, 32.3078],
    // BQ  "加勒比荷兰",
    BS: [-77.39627999999999, 25.03428],
    BT: [90.433601, 27.514162],
    // BV  "布韦岛",
    BW: [24.684866, -22.328474],
    // BX  "比荷卢经济联盟",
    BZ: [-88.49765, 17.189877],
    // CC  "科科斯（基林）群岛",
    CD: [21.758664, -4.038333],
    // CF  "中非",
    CG: [15.827659, -0.228021],
    // CI  "科特迪瓦",
    // CK  "库克群岛",
    CM: [12.354722, 7.369721999999999],
    // CV  "佛得角",
    // CW  "库拉索",
    // CX  "圣诞岛",
    DJ: [42.590275, 11.825138],
    // DM  "多米尼克",
    // EH  "阿拉伯撒哈拉民主共和国",
    // EM  "欧盟知识产权局",
    ER: [39.782334, 15.179384],
    // ES-CT": "加泰罗尼亚",
    ET: [40.489673, 9.145000000000001],
    // EU  "欧盟",
    // FJ  "斐济",
    FK: [-59.523613, -51.796253],
    // FM  "密克罗尼西亚联邦",
    // FO  "法罗群岛",
    GA: [11.609444, -0.803689],
    // GD  "格林纳达",
    GF: [-53.125782, 3.933889],
    // GG  "根西",
    GH: [-1.023194, 7.946527],
    // GI  "直布罗陀",
    GL: [-42.604303, 71.706936],
    GM: [-15.310139, 13.443182],
    GN: [-9.696645, 9.945587],
    // GP  "瓜德罗普",
    GQ: [10.267895, 1.650801],
    // GS  "南乔治亚和南桑威奇群岛",
    // GU  "关岛",
    GW: [-15.180413, 11.803749],
    GY: [-58.93018, 4.860416],
    // HM  "赫德岛和麦克唐纳群岛",
    HT: [-72.285215, 18.971187],
    // IM  "马恩岛",
    // IO  "英属印度洋领地",
    IQ: [43.679291, 33.223191],
    IR: [53.688046, 32.427908],
    // JE  "泽西",
    JM: [-77.297508, 18.109581],
    KG: [74.766098, 41.20438],
    KH: [104.990963, 12.565679],
    // KI  "基里巴斯",
    // KM  "科摩罗",
    // KN  "圣基茨和尼维斯",
    KP: [127.510093, 40.339852],
    KW: [47.481766, 29.31166],
    // KY  "开曼群岛",
    // LC  "圣卢西亚",
    // LI  "列支敦士登",
    LK: [80.77179699999999, 7.873053999999999],
    LR: [-9.429499000000002, 6.428055],
    LS: [28.233608, -29.609988],
    LY: [17.228331, 26.3351],
    // MF  "法属圣马丁",
    MG: [46.869107, -18.766947],
    // MH  "马绍尔群岛",
    ML: [-3.996166, 17.570692],
    MM: [95.956223, 21.913965],
    // MP  "北马里亚纳群岛",
    // MQ  "马提尼克",
    MR: [-10.940835, 21.00789],
    // MS  "蒙特塞拉特",
    // MU  "毛里求斯",
    // MV  "马尔代夫",
    NA: [18.49041, -22.95764],
    NC: [165.618042, -20.904305],
    NE: [8.081666, 17.607789],
    // NF  "诺福克岛",
    NG: [8.675277, 9.081999],
    NP: [84.12400799999999, 28.394857],
    // NR  "瑙鲁",
    // NU  "纽埃",
    OM: [55.923255, 21.512583],
    // PF  "法属波利尼西亚",
    PG: [143.95555, -6.314992999999999],
    PK: [69.34511599999999, 30.375321],
    // PM  "圣皮埃尔和密克隆",
    // PN  "皮特凯恩群岛",
    PR: [-66.590149, 18.220833],
    // PS  "巴勒斯坦",
    // PW  "帕劳",
    QA: [51.183884, 25.354826],
    // RE  "留尼汪",
    RW: [29.873888, -1.940278],
    SB: [160.156194, -9.64571],
    // SC  "塞舌尔",
    SD: [30.217636, 12.862807],
    // SH  "圣赫勒拿",
    // SJ  "挪威 斯瓦尔巴群岛和扬马延岛",
    SL: [-11.779889, 8.460555],
    SN: [-14.452362, 14.497401],
    SO: [46.199616, 5.152149],
    SR: [-56.027783, 3.919305],
    SS: [31.3069788, 6.876991899999999],
    // ST  "圣多美和普林西比",
    // SX  "荷属圣马丁",
    SY: [38.996815, 34.80207499999999],
    SZ: [31.465866, -26.522503],
    // TC  "特克斯和凯科斯群岛",
    TD: [18.732207, 15.454166],
    // TF  "法属南部领地",
    // TG  "多哥",
    // TK  "托克劳",
    TL: [125.727539, -8.874217],
    TM: [59.556278, 38.969719],
    // TO  "汤加",
    // TV  "图瓦卢",
    TZ: [34.888822, -6.369028],
    UG: [32.290275, 1.373333],
    // UM  "美国本土外小岛屿",
    // VA  "梵蒂冈",
    // VC  "圣文森特和格林纳丁斯",
    // VG  "英属维尔京群岛",
    // VI  "美属维尔京群岛",
    VU: [166.959158, -15.376706],
    // WF  "瓦利斯和富图纳",
    // WS  "萨摩亚",
    YE: [48.516388, 15.552727],
};
export default centroids;
//# sourceMappingURL=centroids.js.map